module.exports = __webpack_public_path__ + "static/media/wijn-wit-glas.6441d557.png";